import React, {Component} from 'react'
import Axios from 'axios';
import './NoticesDetail.css'
import {Link} from 'react-router-dom';
import {Breadcrumb} from 'antd'

export default class NoticesDetail extends Component {

    state = {
        NoticesData: [],
        relativeNoticesData: [],
        id: 0,
        totalOfNotices: 0,//公告相关的总数
    }

    componentDidMount() {
        const data = this.props.location.data
        const id = this.props.match.params.id
        console.log(id)

        Axios.get(global.url.news + "/notice/selectOne/" + id)   //-- 换成我   获取详情新闻
            .then(res => {

                console.log(res)
                this.setState({
                    NoticesData: res.data.payload    // -- 换成  把'[id]'给去掉
                })
            })

        // Axios.get('../../data/relativeNewsData.json')
        // http://192.168.158.13:9527/api/news-announcement/notice/related?id=1&limit=4&page=1
        Axios.get(global.url.news + `/notice/related?id=${id}&limit=4&page=1`)        // 获取相关公告
            .then(res => {
                // debugger
                console.log(res.data)
                this.setState({
                    relativeNoticesData: res.data.payload.records,
                    totalOfNotices: res.data.payload.total
                })
            })
    }

    componentDidUpdate(newprops) {
        if (newprops.match.params.id !== this.props.match.params.id) {
            window.location.reload()
        }
    }

    changeRelativeNotices = async () => {
        const id = this.props.match.params.id
        let num = Math.floor(this.state.totalOfNotices / 4)
        let pageNum = Math.floor(Math.random() * (num + 1))
        const {data: res} = await Axios.get(`${global.url.news}//notice/related?id=${id}&limit=4&page=${pageNum}`)
        if (res.code === '200') {
            this.setState({
                relativeNoticesData: res.payload.records
            })
        }
    }

    render() {

        return (
            <div className='newsBox'>
                <div style={{height: '56px', width: '100%', paddingTop: '16px'}}>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <Link to={'/'}>首页</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <Link to={'/NewsBulletin'}>新闻公告</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            {this.state.NoticesData.title}
                        </Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                <div className="content_box">
                    <div className='News_margin News_article'>
                        <div className='NewsDetail_individual'>
                            <div
                                className='NewsDetail_individual_title News_title_margin'>{this.state.NoticesData.title}</div>
                            {/* <div className='NewsDetail_individual_time'>{this.state.NoticesData.created}</div> */}
                            <div className='NewsDetail_individual_time'>{new Date(this.state.NoticesData.created).toLocaleString().replace(/T/, ' ').replace(/\.\d+/, '')}</div>
                            <div className='NewsDetail_individual_tag Tags_margin'>自主</div>
                            <div></div>
                            <div id="divider" className='News_title_margin News_margin'></div>
                        </div>

                        {/* <div className='NewsDetail_summary'>
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;{this.state.NoticesData.summary}</p>
                    </div> */}

                        <div className='NewsDetail_content'
                             dangerouslySetInnerHTML={{__html: this.state.NoticesData.content}}>
                        </div>
                        <div id="divider" className='News_title_margin News_margin'></div>
                        <div className='NewsDetail_author'>编者：{this.state.NoticesData.author}</div>
                    </div>

                    <div className='NewsDetail_more News_margin'>
                        <div className='NewsDetail_more_title'>
                            <div id='decorationBox' className='inline_box'></div>
                            <div onClick={() => this.changeRelativeNotices()}
                                 className='NewsDetail_more_change'>换一批
                            </div>
                            <div className='NewsDetail_more_line'></div>
                        </div>

                        <div className='NewsDetail_more_news'>
                            {
                                this.state.relativeNoticesData.map((data, index) => {
                                    let newsTag;
                                    let newsText;
                                    {
                                        if (data.editMode == 'transfer') {
                                            newsTag = 'news_tag_self_transfer_detail';
                                            newsText = '转载'
                                        } else {
                                            newsTag = 'news_tag_self_detail';
                                            newsText = '自主'
                                        }
                                    }

                                    return (
                                        <Link to={`/NewsBulletin/Notice/${data.id}`} key={data.id}>
                                            <div className='NoticesDetail_more_newsbox'>
                                                <div className="NoticesTitle_line">
                                                    <div className='NoticesDetail_more_newsbox_title'>{data.title}</div>
                                                    <span
                                                        className='NoticesDetail_more_newsbox_time'>{data.created.slice(0, 10)}</span>
                                                </div>
                                                <div className='NoticesDetail_more_newsbox_content'>
                                                    {/* <img className='NewsDetail_more_newsbox_newsPic' src={data.thumbnail}></img> */}

                                                    {/* <div className={newsTag}>{newsText}</div> */}

                                                    <div className='NoticesDetail_more_newsbox_text'
                                                         // dangerouslySetInnerHTML={{__html: this.state.NoticesData.content}}></div>
                                                         dangerouslySetInnerHTML={{__html: data.content}}></div>
                                                    <Link className='NoticesDetail_more_newsbox_details'
                                                          to={`/NewsBulletin/Notice/${data.id}`}>
                                                        【详细】
                                                    </Link>
                                                </div>
                                            </div>
                                        </Link>
                                    )
                                })
                            }

                        </div>
                    </div>
                </div>

                <div style={{clear: 'both'}}></div>
                <div style={{display: 'block', height: '125px', width: '100%'}}></div>

            </div>
        )
    }
}
